import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const CloseIcon = ({
  color,
  width = 40,
  height = 40,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
  [x: string]: unknown;
}) => {
  const { token } = useToken();
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M25.4608 24.6648C25.513 24.7171 25.5545 24.7792 25.5828 24.8474C25.6111 24.9157 25.6256 24.9889 25.6256 25.0628C25.6256 25.1367 25.6111 25.2099 25.5828 25.2782C25.5545 25.3465 25.513 25.4085 25.4608 25.4608C25.4085 25.513 25.3465 25.5545 25.2782 25.5828C25.2099 25.6111 25.1367 25.6256 25.0628 25.6256C24.9889 25.6256 24.9157 25.6111 24.8474 25.5828C24.7792 25.5545 24.7171 25.513 24.6648 25.4608L20.0003 20.7955L15.3358 25.4608C15.2302 25.5663 15.0871 25.6256 14.9378 25.6256C14.7885 25.6256 14.6454 25.5663 14.5398 25.4608C14.4343 25.3552 14.375 25.2121 14.375 25.0628C14.375 24.9135 14.4343 24.7704 14.5398 24.6648L19.2051 20.0003L14.5398 15.3358C14.4343 15.2302 14.375 15.0871 14.375 14.9378C14.375 14.7885 14.4343 14.6454 14.5398 14.5398C14.6454 14.4343 14.7885 14.375 14.9378 14.375C15.0871 14.375 15.2302 14.4343 15.3358 14.5398L20.0003 19.2051L24.6648 14.5398C24.7704 14.4343 24.9135 14.375 25.0628 14.375C25.2121 14.375 25.3552 14.4343 25.4608 14.5398C25.5663 14.6454 25.6256 14.7885 25.6256 14.9378C25.6256 15.0871 25.5663 15.2302 25.4608 15.3358L20.7955 20.0003L25.4608 24.6648Z"
        fill={color ?? token.colorText}
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default CloseIcon;
